var hostname = window.location.href;
const env = {
    BASE_API_URL: hostname.includes('localhost') ? 'http://localhost:7400' : 'https://api.lefoperations.com',
    RECAPTCHA_KEY: '6Lc73egjAAAAAJQWUEdKVehuoduGEuZpC9Y37ehN',
    downloadConfig: {
        responseType: 'blob',
    },
    SWIFT_API_KEY: '113a7ea1-fcdc-4925-aa36-5af1deab95f8',
};

export default env;
